/* eslint-disable @typescript-eslint/no-explicit-any */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { HYDRATE } from 'next-redux-wrapper';
import { State } from './type';

const initialState: State = {
  deviceType: 'desktop',
  showMobileNavBar: false,
  islogin: false,
  email: '',
  loginEmail: '',
  accessToken: '',
  refreshToken: '',
  modalVisible: false,
  displayName: '',
  user: {},
  currentPage: '',
  isNextGenSupported: false,
};

const commonSlice = createSlice({
  name: 'common',
  initialState,
  reducers: {
    updateLoginStatus: (state, action: PayloadAction<any>) => {
      state.islogin = !!action.payload;
      state.displayName = action.payload.displayName;
      state.loginEmail = action.payload.email;
      state.accessToken = action.payload.accessToken;
      state.refreshToken = action.payload.refreshToken;
      state.user = {
        userId: action.payload.userId,
        userName: action.payload.displayName,
      };
    },
    updateModalVisible: (state, action: PayloadAction<boolean>) => {
      state.modalVisible = action.payload;
    },
    updateDisplayName: (state, action: PayloadAction<string>) => {
      state.displayName = action.payload;
    },
    toggleMobileNavBar: (state, action: PayloadAction<boolean>) => {
      state.showMobileNavBar = action.payload;
    },
    updateCurrentPage: (state, action: PayloadAction<string>) => {
      state.currentPage = action.payload;
    },
    updateUserAgentDetails: (state, action: PayloadAction<any>) => {
      state.isNextGenSupported = action.payload.isNextGenSupported;
      state.deviceType = action.payload.deviceType;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(HYDRATE, (state, action: any) => {
      return { ...state, ...action.payload.common };
    });
  },
});

export const {
  updateLoginStatus,
  updateModalVisible,
  updateDisplayName,
  toggleMobileNavBar,
  updateCurrentPage,
  updateUserAgentDetails,
} = commonSlice.actions;

export default commonSlice.reducer;
